import { graphql } from "@opensea/graphql"
import { ProfileMetadataChipFragment } from "./ProfileMetadataChip.fragment"

export const ProfileMetadataChipsFragment = graphql(
  `
    fragment ProfileMetadataChips on Profile {
      ...ProfileMetadataChip
    }
  `,
  [ProfileMetadataChipFragment],
)
